













import blockMixin from './../BlockMixin.vue'

export default {
  name: 'gist'

  mixins: [blockMixin]

  data: -> {
    fields: {
      url: ''
    }
  }

  mounted: ->
    this.$el.firstChild.focus() if this.block.fields.url.length <= 0

  methods: {
    test: ->
      debugger

    loadGist: (event) ->
      url = event.target.value
      return if url == ''
      this.block.fields.url = url

      gistFrame = document.createElement('iframe')
      gistFrame.className = 'bb8-block-gist-iframe'

      previewContainer = this.$el.querySelector('.bb8-block-gist-preview')
      previewContainer.innerHTML = ''
      previewContainer.appendChild(gistFrame)

      gistFrameHTML = '<html><head><base target="_parent"></head><body style="margin:0;"><script src="' + url + '.js"></sc'+'ript></body></html>'
      gistFrameDoc = gistFrame.document

      if gistFrame.contentDocument
        gistFrameDoc = gistFrame.contentDocument
      else if gistFrame.contentWindow
        gistFrameDoc = gistFrame.contentWindow.document

      gistFrameDoc.open()
      gistFrameDoc.writeln(gistFrameHTML)
      gistFrameDoc.close()

    removeBlock: (event, checkUrl = false) ->
      return if checkUrl && event.target.value.length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/GistBlock.vue